import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const UnitService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/units", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/units/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    const response = await apiService.get("/units");
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/units/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/units/${id}`);
    return response.data;
  },

  // unit conversion service===============================
  getUnitConversion: async () => {
    const response = await apiService.get("/unitconversions");
    return response.data;
  },
  createConversion: async (data) => {
    const response = await apiService.post("/unitconversions", data);
    return response.data;
  },
  updateConversion: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/unitconversions/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  deleteConversion: async (id) => {
    const response = await apiService.delete(`/unitconversions/${id}`);
    return response.data;
  },
};

export default UnitService;
